module.exports = {"ja":"日本語","en":"English"}


//////////////////
// WEBPACK FOOTER
// ./src/Lang.json
// module id = 1562
// module chunks = 0